import React, { useEffect, useState } from 'react'
import SlidingPane from "react-sliding-pane";
import MaterialTable, { MTableToolbar } from 'material-table';
import DatePicker from "react-datepicker";
import _ from "lodash";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'

import { getTrans as t } from "../../../../Localization/translations";
import Helper from '../../../../Helper';
import { API } from '../../../../backend';
import authHeader from '../../../../services/auth-header';

const TaxRates = () => {
  const tableRef = React.createRef();

  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [selectedValue3, setSelectedValue3] = useState("");
  const [selectedValue5, setSelectedValue5] = useState(new Date());
  const [selectedValueenddate, setSelectedValueEndate] = useState("");

  const [selectedValue, setSelectedValue] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [city, setCity] = useState("")
  const [county, setCounty] = useState("")
  const [TaxState, setTaxState] = useState([]);

  const handelSearch = () => {
    tableRef.current.onQueryChange();
  };

  const handleClear = () => {
    setSelectedValue("");
    setZipcode("");
    setCity("")
    setSelectedValue3('');
    setSelectedValue5(new Date());
    setSelectedValueEndate('')
    setCounty("")

    tableRef.current.onQueryChange();
  };

  // const range = {
  //   "Today": [moment(), moment()],
  //   "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
  //   "Last 7 Days": [moment().subtract(6, "days"), moment()],
  //   "Last 30 Days": [moment().subtract(29, "days"), moment()],
  //   "This Month": [moment().startOf("month"), moment().endOf("month")],
  //   "Last Month": [
  //     moment()
  //       .subtract(1, "month")
  //       .startOf("month"),
  //     moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //   ],
  //   "Last Year": [
  //     moment()
  //       .subtract(1, "year")
  //       .startOf("year"),
  //     moment()
  //       .subtract(1, "year")
  //       .endOf("year")
  //   ]
  // };

  // const handleEvent2 = (event, picker) => {
  //   setSelectedValue3(picker.startDate);
  //   setSelectedValueEndate(picker.endDate);
  // };

  // const clearDates = () => {
  //   setSelectedValue3('');
  //   setSelectedValueEndate('')
  // };

  useEffect(() => {
    // if (TaxCoutryId !== "") {
    const getstate = async () => {
      const resst = await fetch(API + "helper/ajax/load-states/" + 231 + "/");
      const getst = await resst.json();
      setTaxState(await getst);
    };
    getstate();
    // }
  }, []);

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setSelectedValue(getstateid);
  };

  const handelChangebilling = (value) => {
    setSelectedValue3(value);
  };
 
  const handelEndDate = (value) => {
    setSelectedValue5(value);
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10; // Your page size

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      let state_name = "";
      let zip_code_name = "";
      let city_name = "";
      let county_rate = ""

      if (selectedValue && zipcode && city && county) {
        state_name = selectedValue;
        zip_code_name = zipcode;
        city_name = city;
      } else if (selectedValue) {
        state_name = selectedValue;
      } else if (zipcode) {
        zip_code_name = zipcode;
      } else if (city) {
        city_name = city;
      } else if (county) {
        county_rate = county;
      }

      let url = API + "accounting/tax-ratesreports/?";
      url += "&per_page=" + query.pageSize;
      url += "&page=" + (query.page + 1);
      url += "&search=" + query.search;
      url += `&state=${state_name !== "" ? state_name : ""}`;
      url += `&zip=${zip_code_name !== "" ? zip_code_name : ""}`;
      url += `&start_date=${selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : ""}`;
      url += `&end_date=${selectedValue5 !== "" ? Helper.DatePicker(selectedValue5?selectedValue5: new Date()) : ""}`;

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  return (
    <div className="page-wrapper">
      <div className="">
        {/* {loading === false ? ( */}
        <div className="row show_contract show_invoice">
          <div className="col-md-12">
            <div className=" mb-0">
              <div className="body">
                <div className="table-responsive p-0">
                  <MaterialTable
                    tableRef={tableRef}
                    style={{
                      backgroundColor: "var(--bs-table-bg)",
                      borderBottomWidth: "1px",
                      boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                    }}
                    title={<h5>{t("Tax Rates")} </h5>}
                    columns={[
                      {
                        title: `${t("State")}`,
                        field: "state_name",
                        editable: "never",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("State")}
                            </div>
                            <div
                            // onClick={() => handleView(rowData.id)}
                            >
                              {rowData.state_name}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Zip Code")}`,
                        field: "zip",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Zip Code")}
                            </div>
                            <div>{rowData.zip}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Tax Region")}`,
                        field: "tax_region",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Tax Region")}
                            </div>
                            <div>{rowData.tax_region}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Combined Rate")}`,
                        field: "combined_rate",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Combined Rate")}
                            </div>
                            <div>{Helper.TaxRateAmount(rowData.combined_rate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("State Rate")}`,
                        field: "state_rate",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("State Rate")}
                            </div>
                            <div>{Helper.TaxRateAmount(rowData.state_rate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("County Rate")}`,
                        field: "county_rate",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("County Rate")}
                            </div>
                            <div>{Helper.TaxRateAmount(rowData.county_rate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("City Rate")}`,
                        field: "city_rate",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("City Rate")}
                            </div>
                            <div>{Helper.TaxRateAmount(rowData.city_rate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Special Rate")}`,
                        field: "special_rate",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Special Rate")}
                            </div>
                            <div>{Helper.TaxRateAmount(rowData.special_rate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Start Date")}`,
                        field: "start_date",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Start Date")}
                            </div>
                            <div>
                              {rowData.start_date
                                ? Helper.DateNormal(rowData.start_date)
                                : "None"}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("End Date")}`,
                        field: "end_date",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("End Date")}
                            </div>
                            <div>
                              {rowData.end_date
                                ? Helper.DateNormal(rowData.end_date)
                                : "None"}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                    ]}
                    data={
                      // permissionss && permissionsArray.includes('view_tax') === true ?
                      (query) =>
                        new Promise((resolve, reject) => {
                          const { orderBy, orderDirection } = query;
                          let state_name = "";
                          let zip_code_name = "";
                          let city_name = "";
                          let county_rate = ""

                          if (selectedValue && zipcode && city && county) {
                            state_name = selectedValue;
                            zip_code_name = zipcode;
                            city_name = city;
                          } else if (selectedValue) {
                            state_name = selectedValue;
                          } else if (zipcode) {
                            zip_code_name = zipcode;
                          } else if (city) {
                            city_name = city;
                          } else if (county) {
                            county_rate = county;
                          }

                          let url = API + "accounting/tax-ratesreports/?";
                          url += "&per_page=" + query.pageSize;
                          url += "&page=" + (query.page + 1);
                          url += "&search=" + query.search;
                          url += `&state=${state_name !== "" ? state_name : ""}`;
                          url += `&zip=${zip_code_name !== "" ? zip_code_name : ""}`;
                          url += `&start_date=${selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : ""}`;
                          url += `&end_date=${selectedValue5 !== "" ? Helper.DatePicker(selectedValue5?selectedValue5: new Date()) : ""}`;
                          if (orderBy) {
                            url += `&orderBy=${orderBy.field}`;
                            url += `&orderDirection=${orderDirection}`;
                          }
                          fetch(url, { headers: authHeader() })
                            .then((response) => response.json())
                            .then((result) => {
                              resolve({
                                data:
                                  query.orderBy && query.orderDirection
                                    ? _.orderBy(
                                      result.data,
                                      [query.orderBy.field],
                                      [query.orderDirection]
                                    )
                                    :
                                    result.data,
                                page: result.page - 1,
                                totalCount: result.total,
                              });
                            });
                        })
                      // : []
                    }
                    components={{
                      Toolbar: (props) => (
                        <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                          <MTableToolbar {...props} />
                          <span
                            onClick={() => setState({ isPaneOpen: true })}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "1px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-filter.svg"
                              }
                              alt="filter"
                            />
                          </span>
                        </div>
                      ),
                      // Container: (props) => (
                      //   <div id="Payment">
                      //     <Paper {...props} />
                      //   </div>
                      // ),
                    }}
                    options={{
                      headerStyle: {
                        backgroundColor: "white",
                        color: "#245C7F",
                        fontSize: 12,
                      },
                      rowStyle: (rowData, index) => {
                        if (index % 2) {
                          return { backgroundColor: "#fff" };
                        }
                      },
                      sorting: true,
                      search: true,
                      toolbar: true,
                      paging: true,
                      pageSize: 10, // make initial page size
                      emptyRowsWhenPaging: false, // To avoid of having empty rows
                      pageSizeOptions: [10, 25, 50, 100],
                      paginationType: "stepped",
                      showFirstLastPageButtons: false,
                      exportAllData: true,
                      exportButton: true,
                      exportFileName: "Taxrate Reports",
                      actionsColumnIndex: -1,
                      columnsButton: true,
                      exportCsv: async (columns, data) => {
                        try {
                          const allData = await fetchAllDataForExport(); // Fetch all data
                          if (allData.length === 0) {
                            console.error("No data found for CSV export");
                            return;
                          }

                          const csvColumns = Helper.visibleColumn(columns); // Filter out hidden columns
                          const csvColumnTitles = csvColumns.map(column => column.title);

                          const title = "Taxrate Report";
                          const currentDate = new Date().toLocaleDateString();

                          let csvContentWithInfo = `${title}\n`;
                          if (selectedValue !== '') {
                            const selectedVal = selectedValue;
                            csvContentWithInfo += `Filter By state Name : ${selectedVal}\n`;
                          }
                          if (zipcode !== '') {
                            const selectedVal2 = zipcode;
                            csvContentWithInfo += `Filter By Zipcode : ${selectedVal2}\n`;
                          }
                          if (city !== '') {
                            const cityData = city;
                            csvContentWithInfo += `Filter By city : ${cityData}\n`;
                          }
                          csvContentWithInfo += `Date: ${currentDate}\n\n`;

                          const csvData = allData.map(rowData =>
                            csvColumns.map(columnDef => {
                                return rowData[columnDef.field];
                            })
                          );

                          const csvRows = [csvColumnTitles, ...csvData];
                          const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;

                          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                          const link = document.createElement('a');
                          link.href = URL.createObjectURL(blob);
                          link.download = 'Taxrate.csv';
                          link.style.display = 'none';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        } catch (error) {
                          console.error("Error exporting CSV:", error);
                        }
                      },
                      exportPdf: async (columns, data) => {
                        const allData = await fetchAllDataForExport(); // Fetch all data
                        if (allData.length === 0) {
                            console.error("No data found for PDF export");
                            return;
                        }
                    
                        // Filter out hidden columns
                        const visibleColumns = Helper.visibleColumn(columns);
                        
                        const doc = new jsPDF();
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(16);
                    
                        const title = "Taxrate Report";
                        doc.text(title, 14, 10);
                    
                        doc.setFontSize(12);
                        doc.setFont("helvetica", "normal");
                        const currentDate = new Date().toLocaleDateString();
                        doc.text(`Date : ${currentDate}`, 14, 15);
                        const selectedVal = selectedValue;
                        const selectedVal2 = zipcode;
                        const selectedVal3 = city;
                        if (selectedValue !== '') {
                           if(selectedValue !== '' && zipcode !== '' && city !== ''){
                            doc.text(`Filter By State, Zipcode and City : ${selectedVal === ''?"":selectedVal} , ${selectedVal2 ===''?"":selectedVal2} and ${selectedVal3 === ''?"":selectedVal3}`, 14, 20);
                          }
                        }
                        else if (selectedValue!== ''){
                          doc.text(`Filter By State : ${selectedVal === ''?"":selectedVal} `, 14, 20);
                        }
                        else if(zipcode!==''){
                          doc.text(`Filter By  zipcode : ${selectedVal2 === ''?"":selectedVal2}`, 14, 20);
                        }
                        else if(city!==''){
                          doc.text(`Filter By  city : ${selectedVal3 === ''?"":selectedVal3}`, 14, 20);
                        }
                    
                        // Set the space between the filter title and the table
                        const space = 22; // Adjust the space value as needed
                        const tableStartY = 5 + space;
                    
                        const columnTitles = visibleColumns.map(columnDef => columnDef.title);
                        const pdfData = allData.map(rowData =>
                            visibleColumns.map(columnDef => {
                                    return rowData[columnDef.field];
                            })
                        );
                        const tableData = [columnTitles, ...pdfData];
                    
                        // Draw the table with adjusted y-coordinate
                        // doc.autoTable({
                        autoTable(doc,{
                            head: [tableData[0]], // Column headers
                            body: tableData.slice(1), // Data excluding headers
                            startY: tableStartY ,// Set the starting y-coordinate for the table
                            columnStyles: visibleColumns // Apply column alignment styles

                        });
                    
                        doc.save(`Taxrate.pdf`);
                    },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={state1.isPaneOpen}
        title="Filter By"
        subtitle=""
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
      >
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">{t("State")}</label>
            <div className="col-lg-12">
              <select
                name="state"
                className="form-control"
                onChange={handlestate}
                value={selectedValue}
              >
                <option value="">---Select State---</option>
                {TaxState.map((resst, i) => (
                  <option key={i} value={resst.name}>
                    {resst.name}
                  </option>
                ))}
              </select>
            </div>
            <label className="col-lg-12 col-form-label">{t("Zip")}</label>
            <div className="">
              <input
                className="form-control"
                placeholder="Zip"
                value={zipcode}
                onChange={(e) => setZipcode(e.target.value)}
              />
            </div>
            {/* <label className="col-lg-12 col-form-label">{t("City Rate")}</label>
            <div className="">
              <input
                className="form-control"
                placeholder="City Rate"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
            <label className="col-lg-12 col-form-label">{t("county Rate")}</label>
            <div className="">
              <input
                className="form-control"
                placeholder="County Rate"
                value={county}
                onChange={(e) => setCounty(e.target.value)}
              />
            </div> */}
            <label className="col-lg-12 col-form-label">
              {t("Start Date")}
            </label>
            <div className=''>
              <DatePicker
                className="form-control datepick"
                selected={selectedValue3}
                onChange={(e) => handelChangebilling(e)}
                placeholderText={"mm/dd/yyyy"}
                showYearDropdown // year show and scrolldown alos
                scrollableYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
            </div>
            <label className="col-lg-12 col-form-label">
              {t("End Date")}
            </label>
            <div className=''>
              <DatePicker
                className="form-control datepick"
                selected={selectedValue5}
                onChange={(e) => handelEndDate(e)}
                placeholderText={"mm/dd/yyyy"}
                showYearDropdown // year show and scrolldown alos
                scrollableYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
            </div>
            {/* <div className="col-lg-12 position-relative">
              <DateRangePicker
                initialSettings={{ ranges: range }}
                startDate={selectedValue3 !== "" ? selectedValue3 : ""}
                // endDate={selectedValueenddate !== "" ? selectedValueenddate : ""}
                alwaysShowCalendars={true}
                onEvent={handleEvent2}
              >
                <div className="form-control d-flex justify-content-between align-items-center">
                  <span>
                    {selectedValue3 !== '' ? Helper.DateNormal(selectedValue3) : "Select Start Date"} to {selectedValueenddate !== "" ? Helper.DateNormal(selectedValueenddate) : 'Select End Date'}
                  </span>

                </div>
              </DateRangePicker>
              {(selectedValue3 !== '' || selectedValueenddate !== "") && (
                <CloseIcon onClick={clearDates} style={{ position: 'absolute', top: '50%', right: '20px', transform: 'translateY(-50%)', cursor: 'pointer', height: '20px', width: '20px', color: '#b8b5b5' }} />
              )}
            </div> */}
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
              <button
                type="button"
                className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                onClick={handleClear}
              >
                {t("Reset")}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="filter add btn btn-primary btn-m ms-auto mb-0"
                onClick={handelSearch}
              >
                {t("Apply")}
              </button>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </SlidingPane>
    </div>
  )
}

export default TaxRates